import { render, staticRenderFns } from "./Lot.vue?vue&type=template&id=8b91c572&scoped=true"
import script from "./Lot.vue?vue&type=script&lang=js"
export * from "./Lot.vue?vue&type=script&lang=js"
import style0 from "./Lot.vue?vue&type=style&index=0&id=8b91c572&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b91c572",
  null
  
)

export default component.exports